<div class="content-wrapper">
  <app-page-header>Browse new products</app-page-header>
  <app-header-summary
    [currentItem]="offers?.current_item"
    [currentPlan]="offers?.current_plan"
  >
  </app-header-summary>

  <div id="replacement" class="header">
    <div class="container">
      <a
        routerLink="/tips"
        queryParamsHandling="merge"
        class="link typog-body-large-bold"
        ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
      >
      <div class="text--center">
        <h5>Choose a free model similar to your old one</h5>
        <a
          (click)="scrollIntoView('upgrade')"
          class="link typog-body-large-bold"
          *ngIf="
            (
              offers?.replacement_offers
              | filterDataByOfferType : OfferType.UPGRADE
            )?.length
          "
          >Or pay for an upgraded model</a
        >
      </div>
    </div>
  </div>

  <app-offer-container
    [replacementOffers]="
      offers?.replacement_offers | filterDataByOfferType : OfferType.REPLACEMENT
    "
    [rrpFlag]="offers?.offer?.rrp_flag"
    [showMoreSize]="3"
    [comparisonsSelected]="comparisons$ | async"
    (comparisonClicked)="onComparisonClick($event)"
    (showMoreClicked)="onShowMoreClick($event)"
    (cardClicked)="onCardClick($event)"
  >
  </app-offer-container>

  <div
    class="enhanced"
    *ngIf="
      (offers?.replacement_offers | filterDataByOfferType : OfferType.UPGRADE)
        ?.length
    "
  >
    <div class="container" id="upgrade">
      <div class="text--center pt-10 pb-6">
        <h5>Here are your upgrade options</h5>
        <a
          (click)="scrollIntoView('replacement')"
          class="link typog-body-large-bold"
          *ngIf="
            (
              offers?.replacement_offers
              | filterDataByOfferType : OfferType.REPLACEMENT
            )?.length
          "
          >Or choose a free model</a
        >
      </div>
    </div>
    <app-offer-container
      [replacementOffers]="
        offers?.replacement_offers | filterDataByOfferType : OfferType.UPGRADE
      "
      [rrpFlag]="offers?.offer?.rrp_flag"
      [showMoreSize]="3"
      [comparisonsSelected]="comparisons$ | async"
      (comparisonClicked)="onComparisonClick($event)"
      (showMoreClicked)="onShowMoreClick($event)"
      (cardClicked)="onCardClick($event)"
    >
    </app-offer-container>
  </div>
</div>

<app-compare-container
  class="sticky-element"
  [comparisonsSelected]="comparisons$ | async"
  [currentItem]="offers?.current_item"
  (mediumComparisonRemoved)="onComparisonClick($event)"
  (largeComparisonRemoved)="onComparisonClick($event)"
  (compareClicked)="onCompareClicked()"
  (compareModelsClicked)="onCompareModelsClick()"
  (comparisonSelected)="onComparisonSelectedClick($event)"
></app-compare-container>
